import $ from 'jquery';

export const elements = {
    excluded: ':input:not(textarea):not([type=submit]):not(button)',
};

export const onKeypress = (callback, event) => {
    if (event.keyCode == 13) {
        event.preventDefault();
    }
};

$.fn.disableEnterSubmit = function (callback) {
    return $(this).on('keypress', elements.excluded, $.proxy(onKeypress, null, callback));
};

export default $;



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/utils/jquery/disable-enter-submit.js